import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const AnswersCard = ({ title, answers }: { title: string; answers: { question: string; answer: string }[] }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Answers>
        {answers.map((answer) => (
          <Answer key={answer.question}>
            <Question>{answer.question}</Question>
            <AnswerText>{answer.answer}</AnswerText>
          </Answer>
        ))}
      </Answers>
    </Container>
  ) as React.ReactNode;
};

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.neutral.white,
  padding: '16px',
  flexDirection: 'column',
  gap: '10px',
  borderRadius: '8px',
  textAlign: 'left',
}));

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins Medium, sans-serif',
  color: theme.palette.blue[60],
}));

const Answers = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}));

const Answer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

const Question = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins SemiBold, sans-serif',
  color: theme.palette.neutral[60],
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

const AnswerText = styled(Typography)(({ theme }) => ({
  padding: '16px 12px',
  whiteSpace: 'pre-wrap',
  backgroundColor: theme.palette.neutral[10],
  borderRadius: '5px',
  color: theme.palette.neutral[60],
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export default AnswersCard;
export { AnswersCard };
